module.exports = __webpack_public_path__ + "static/media/6.c24c75a6.svg";